import { Component } from "@angular/core";

@Component({
  selector: "bit-nav-divider",
  templateUrl: "./nav-divider.component.html",
})
export class NavDividerComponent {}
